/** Selling Price / TP must not exceed MRP (equal is allowed). */
export function sellingPriceExceedsMrp(sellingPrice, mrp) {
  if (mrp == null || mrp === '') return false
  const tp = Number(sellingPrice)
  const m = Number(mrp)
  if (!Number.isFinite(tp) || !Number.isFinite(m)) return false
  return tp > m
}

export function formatSellingPriceExceedsMrpError(sellingPrice, mrp) {
  return `Selling Price (${sellingPrice}) must not exceed MRP (${mrp})`
}

/** True when value is a finite number strictly greater than 0. */
export function isPositivePrice(value) {
  const n = Number(value)
  return Number.isFinite(n) && n > 0
}

export function formatPriceMustBePositiveError(label) {
  return `${label} must be greater than 0`
}

/**
 * Returns an error message when Selling Price and/or MRP are present but not > 0,
 * or when both are present and Selling Price exceeds MRP. Otherwise null.
 */
export function validatePositiveSellingPriceAndMrp(
  sellingPrice,
  mrp,
  options = {},
) {
  const requireBoth = options.requireBoth === true
  const hasCost =
    sellingPrice !== undefined &&
    sellingPrice !== null &&
    sellingPrice !== ''
  const hasMrp = mrp !== undefined && mrp !== null && mrp !== ''

  if (requireBoth || hasCost) {
    if (!isPositivePrice(sellingPrice)) {
      return formatPriceMustBePositiveError('Selling Price')
    }
  }
  if (requireBoth || hasMrp) {
    if (!isPositivePrice(mrp)) {
      return formatPriceMustBePositiveError('MRP')
    }
  }
  if (
    hasCost &&
    hasMrp &&
    sellingPriceExceedsMrp(Number(sellingPrice), Number(mrp))
  ) {
    return formatSellingPriceExceedsMrpError(
      Number(sellingPrice),
      Number(mrp),
    )
  }
  return null
}
